function Spinner({ message } : { message?: string }) {
    return (
        <div className="bg-transparent flex justify-center items-center w-full">
        <div className="w-12 h-12 mt-4 mb-4 rounded-full animate-spin border-y-2 border-solid border-gray-900 border-t-transparent dark:border-slate-200"></div>
        </div>
    );
}

export default Spinner